var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"ObjectMoreInfoLink",attrs:{"to":{name: 'object', params: {id: _vm.id}}}},[_c('div',{staticClass:"ObjectMoreInfoLink__text"},[_vm._t("default",[_vm._v("Подробнее")])],2),_c('ArrowIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }